var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 5.25H4.5C4.08579 5.25 3.75 5.58579 3.75 6V12C3.75 12.4142 4.08579 12.75 4.5 12.75H18.75C19.1642 12.75 19.5 12.4142 19.5 12V6C19.5 5.58579 19.1642 5.25 18.75 5.25Z",
    stroke: "#2A3842",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 9H21.75C21.9489 9 22.1397 9.07902 22.2803 9.21967C22.421 9.36032 22.5 9.55109 22.5 9.75V14.4375C22.4987 14.6002 22.4451 14.7582 22.3472 14.8881C22.2493 15.0181 22.1123 15.1132 21.9562 15.1594L12.5438 17.8406C12.3877 17.8868 12.2507 17.9819 12.1528 18.1119C12.0549 18.2418 12.0013 18.3998 12 18.5625V21.75",
    stroke: "#2A3842",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 9H1.5",
    stroke: "#2A3842",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusIcon);
export default __webpack_public_path__ + "static/media/statusIcon.d60846ee24428dc903fab1807d465b7a.svg";
export { ForwardRef as ReactComponent };